import { fromJS } from 'immutable';

import {
  updateOrAdd,
  remove,
} from './helper';

import {
  fetchCustomersRoutine,
  saveCustomerRoutine,
  removeCustomerRoutine,
  fetchCustomerRoutine,
  saveCustomerAddressRoutine
} from '../routines';

const initialState = fromJS({
  customers: {},
  customer: {},
  loading: false,
});

export default function (state = initialState, action) {
  // console.log('action', action);
  switch (action.type) {
    // case SET_CUSTOMER:
    //   return state.set('customer', fromJS(action.customer));
    case fetchCustomersRoutine.REQUEST:
      return state.setIn(['customers', 'loading'], true);
    case fetchCustomersRoutine.SUCCESS:
      return state.set('customers', fromJS(action.payload.response));
    case fetchCustomersRoutine.FAILURE:
      return state.setIn(['customers', 'loading'], false);
    case fetchCustomerRoutine.SUCCESS:
      return state.set('loading', false)
        .set('customer', fromJS(action.customer));
    case fetchCustomerRoutine.FAILURE:
      return state.set('loading', false)
        .set('error', fromJS(action.error));

    case saveCustomerRoutine.SUCCESS:
      return state
        .updateIn(['customers', 'data'], updateOrAdd(fromJS(action.payload.response.data)));
    case saveCustomerRoutine.FAILURE:
      console.log('action.error', action.error);
      return state.set('error', action.error).set('saving', false);
    case saveCustomerRoutine.FULFILL:
      return state;

    case removeCustomerRoutine.SUCCESS:
      return state.updateIn(['customers', 'data'], remove(fromJS(action.payload.request)))
        .updateIn(['customers', 'pagination', 'totalCount'], (val) => val - 1);
    case removeCustomerRoutine.FAILURE:
      return state.set('error', action.error);

    case saveCustomerAddressRoutine.SUCCESS:
      console.log('action.payload.request', action.payload.request);
      return state
        .updateIn(['customers', 'data'], (customers) => {
          return customers.map((customer) => {
            if (customer.get('id') === action.payload.request.customer.get('id')) {
              return customer.update('addresses', updateOrAdd(fromJS(action.payload.response.data)));
            }

            return customer;
          });
        });
    default :
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/customers.js